import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'

const Queries = ({ commonQueries, pieName }) => {
    const [query, setquery] = useState([]);

    useEffect(() => {
        setquery(commonQueries)
    }, [commonQueries])

    const labels = Object.keys(query);
    const series = Object.values(query);

    const options = {
        chart: { type: "pie" },
        labels: labels,
        dataLabels: {
            enabled: false,
        },
        colors: ["#BA8E27", "#0f6e5a", '#1b7f68', '#27c08a', '#dbbb6f', '#826013'],
        stroke: { width: 0 },
        legend: { show: false },
    }
    return (
        <div className='shadow-custom rounded-3xl p-5 w-full lg:w-1/3'>
            <p className='text-base font-semibold text-black mb-6'>{pieName}</p>
            <div className="flex mt-7 flex-col doublexl:flex-row items-center">
                <div className="w-full md:w-2/3">
                    <Chart
                        options={options}
                        series={series}
                        type="pie"
                        width="100%"
                    />
                </div>
                <div className=" flex flex-col items-start mt-4 md:mt-0">
                    {options.labels.map((label, index) => (
                        <div
                            key={index}
                            className="flex items-center gap-3 text-sm"
                        >
                            <span
                                className="block w-5 h-2 rounded"
                                style={{ backgroundColor: options.colors[index] }}
                            ></span>
                            <span>{label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Queries